export const ANALYTICS_AGENT_ID = 'analytics-assistant';
export const SUBJECT_LINES_AGENT_ID = 'subject-line-assistant';
export const SMS_MMS_CONVERTER_AGENT_ID = 'creative_channel_converter';
export const PUSH_CONVERTER_AGENT_ID = 'push-assistant';
export const INK_AI_AGENT_ID = 'ink_ai';
export const AUDIENCE_BUILDER_AGENT_ID = 'audience_builder';
